export const it = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Sì",
    No: "No",
    "You cannot go back from this position":
      "Non si può tornare indietro da questa posizione",
    Chapters: "Capitoli",
    Start: "Inizio",
    "Connecting to the Energy Valve":
      "Collegamento alla Energy Valve",
    "Control Source": "Fonte di controllo",
    "Do you know the design flow rate?":
      "Conosci la portata di progetto?",
    "Flow Control": "Regolazione della portata",
    "Is the building running off fixed or varying flow temperatures?":
      "L'edificio funziona con temperature di portata fisse o variabili?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Temperature di portata variabili (Delta T Manager Scaling)",

    "Fixed flow temperatures (Delta T Manager)":
      "Temperature di portata fisse (Delta T Manager)",
    "I am not sure": "Non sono sicuro",
    "Delta T Manager": "Delta T Manager",
    Scaling: "Scalare",
    "Do you know the power output?":
      "Conosci la potenza di uscita?",
    "Yes (Power Control)": "Sì (Controllo di potenza)",
    "No (Position Control)": "No (Controllo di posizione)",
    "Power Control": "Controllo di potenza",
    "Position Control": "Controllo di posizione",
    "Onboard Data Analysis": "Analisi dei dati onboard",
    "Did you get a clear result from the Energy Valve?":
      "Hai ottenuto un risultato chiaro dalla Energy Valve?",
    "How do you want to setup your Energy Valve?":
      "Come vuoi impostare la tua Energy Valve?",
    "Would you like to connect to the cloud?":
      "Vorresti connetterti al cloud?",
    "Cloud Connectivity": "Connettività Cloud",
    "Onboard Diagnostics / Download Data":
      "Diagnostica onboard / Scarica i dati",
    "Download Data": "Download dati",
    "Send optimization request":
      "Invia una richiesta di ottimizzazione",
    End: "Fine",

    Subtitles: "Sottotitoli",
    Repeat: "Ripetere",
    Continue: "Continua",
  },
};
